/**
 * Hero Selector
 * 
 * Dynamically renders the appropriate hero component
 * based on the current layout theme.
 */

import { useLayout } from "@/lib/layout-provider";
import HeroFullImage from "./HeroFullImage";
import HeroSplit from "./HeroSplit";
import HeroVideo from "./HeroVideo";
import HeroGradient from "./HeroGradient";
import HeroCarousel from "./HeroCarousel";
import HeroMinimal from "./HeroMinimal";
import type { HeroStyle } from "@/lib/layout-types";

const heroComponents: Record<HeroStyle, React.ComponentType> = {
  'full-image': HeroFullImage,
  'split-content': HeroSplit,
  'video-background': HeroVideo,
  'gradient-only': HeroGradient,
  'carousel': HeroCarousel,
  'minimal': HeroMinimal,
};

const HeroSelector = () => {
  const { currentLayout } = useLayout();
  const HeroComponent = heroComponents[currentLayout.hero.style] || HeroFullImage;

  return <HeroComponent />;
};

export default HeroSelector;





